import { useTheme } from "styled-components";
import { IStyledTheme } from "theme/types";

export function useAppTheme() {
  const theme = useTheme() as IStyledTheme;

  return theme;
}
